import React from 'react';
import { Card } from 'react-bootstrap';
import { IAssesmentPayload, IScreenType } from './helpers/typings';
import ScreenCard from './ScreenCsrd';
import { cruAssessment } from './helpers/utils';

type AssessmentProps = {
    assessment: IAssesmentPayload;
    onScreenEdit: () => void;
    setAssessmentList: React.Dispatch<
        React.SetStateAction<IAssesmentPayload[]>
    >;
    assmentSelector: (assessment: IAssesmentPayload) => void;
    screenSelector: (screen: IScreenType) => void;
};

const Assessment: React.FC<AssessmentProps> = ({
    assessment,
    onScreenEdit,
    setAssessmentList,
    assmentSelector,
    screenSelector,
}) => {
    const {
        name,
        istest,
        for_discussion,
        discussionid,
        preorpost,
        data: {
            ismandatory,
            successCopy,
            buttonCopies,
            onCompleteAction,
            screens,
        },
    } = assessment;

    const deleteScreen = (id: string) => {
        const newScreens = screens.filter(screen => screen.id !== id);
        cruAssessment(
            {
                ...assessment,
                data: { ...assessment.data, screens: newScreens },
            },
            payload => {
                assmentSelector(payload);
                setAssessmentList(prev =>
                    prev.map(a => (a.id === payload.id ? payload : a)),
                );
            },
        );
    };

    return (
        <div className="w-100">
            <Card className="my-3">
                <Card.Body>
                    <Card.Title className="mb-3 fw-bold fs-4">
                        {name}
                    </Card.Title>

                    <div className="mb-2">
                        <strong>Assessment Id:</strong> {assessment.id}
                    </div>

                    <div className="mb-2">
                        <strong>Assessment Type:</strong>{' '}
                        {istest ? 'Test' : 'Non-Test'}
                    </div>

                    <div className="mb-2">
                        <strong>Assessment Start-Type:</strong>{' '}
                        {preorpost === 'pre' ? 'Pre' : 'Post'}
                    </div>

                    <div className="mb-2">
                        <strong>Discussion ID:</strong> {discussionid || 'N/A'}
                    </div>

                    <div className="mb-2">
                        <strong>Is Mandatory:</strong>{' '}
                        {ismandatory ? 'Yes' : 'No'}
                    </div>

                    <div className="mb-2">
                        <strong>Success Message:</strong> {successCopy || 'N/A'}
                    </div>

                    <div className="mb-2">
                        <strong>Button Labels:</strong>
                        <ul className="mb-0">
                            <li>
                                <strong>Start:</strong>{' '}
                                {buttonCopies?.START || 'N/A'}
                            </li>
                            <li>
                                <strong>Submit:</strong>{' '}
                                {buttonCopies?.SUBMIT || 'N/A'}
                            </li>
                            <li>
                                <strong>Next:</strong>{' '}
                                {buttonCopies?.NEXT || 'N/A'}
                            </li>
                        </ul>
                    </div>

                    <div>
                        <strong>On Complete Action:</strong>{' '}
                        {onCompleteAction || 'N/A'}
                    </div>
                    <h3 className="my-2">Screens:</h3>
                    {screens.map(screen => (
                        <ScreenCard
                            key={screen.id}
                            screen={screen}
                            onScreenEdit={onScreenEdit}
                            screenSelector={screenSelector}
                            deleteScreen={() => deleteScreen(screen.id)}
                        />
                    ))}
                    {screens.length === 0 && <p>No screens available.</p>}
                </Card.Body>
            </Card>
        </div>
    );
};

export default Assessment;
